import {defineMessages} from "@project/i18n";

export const userManagementUserFieldLabelIds = {
  displayName: "fields.userManagementUser.displayName",
  email: "fields.userManagementUser.email",
  username: "fields.userManagementUser.username",
} as const;

export const userManagementUserFieldMessages = defineMessages({
  displayName: {
    id: "fields.userManagementUser.displayName",
    defaultMessage: "Display name",
    description: "User Management user's display name",
  },
  email: {
    id: "fields.userManagementUser.email",
    defaultMessage: "Email",
    description: "User Management invitation email",
  },
  username: {
    id: "fields.userManagementUser.username",
    defaultMessage: "Username",
    description: "User Management invitation username",
  },
});
